import { render, staticRenderFns } from "./ManagementAddContractorInfoSkills.vue?vue&type=template&id=2a1b219c&scoped=true"
import script from "./ManagementAddContractorInfoSkills.vue?vue&type=script&lang=ts"
export * from "./ManagementAddContractorInfoSkills.vue?vue&type=script&lang=ts"
import style0 from "./ManagementAddContractorInfoSkills.vue?vue&type=style&index=0&id=2a1b219c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b219c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a1b219c')) {
      api.createRecord('2a1b219c', component.options)
    } else {
      api.reload('2a1b219c', component.options)
    }
    module.hot.accept("./ManagementAddContractorInfoSkills.vue?vue&type=template&id=2a1b219c&scoped=true", function () {
      api.rerender('2a1b219c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ManagementAddContractorInfoSkills.vue"
export default component.exports